import { useConst } from "@chakra-ui/react";
import { AsyncReturnType } from "type-fest";

import { BillingService } from "@/services/billing-service";
import { UseQuerySimpleOptions, useQuery } from "@/services/hooks";
import { gen, repeat } from "@/utils";

type QueryFnData = AsyncReturnType<typeof BillingService.getPaymentMethods>;
type Error = unknown;

const queryKey = () => ["billing", "payment-methods"];

export const usePaymentMethods = <TData = QueryFnData>(
  options?: UseQuerySimpleOptions<QueryFnData, Error, TData>
) => {
  const result = useQuery<QueryFnData, Error, TData>(
    queryKey(),
    () => BillingService.getPaymentMethods(),
    {
      skeletonData: useConst({
        defaultPaymentMethodStripeId: gen.guid(),
        paymentMethods: repeat(gen.paymentMethod, 1),
      }),
      ...options,
    }
  );

  return result;
};

usePaymentMethods.queryKey = queryKey;
